import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import { Route, Routes } from 'react-router-dom';
import { Seasons } from './Seasons';
import { Statistics } from './Statistics';
import { Admin } from './Admin';
import Container from 'react-bootstrap/Container';
import { LoginForm } from './user/LoginForm';
import TeamDetails from './TeamDetails';
import MatchDetails from './MatchDetails';
import AddMatchResult from './AddMatchResult';
import { Breadcrumbs } from '../modules/Breadcrumbs';
import { Clubs } from './Clubs';
import { FutureMatches } from './FutureMatches';

const MainContainer = () => {
  return (
    <Container fluid className="flex-container" style={{ maxWidth: '1400px' }}>
      <Routes>
        <Route
          path="/login"
          element={
            <Container>
              <LoginForm />
            </Container>
          }
        />
        <Route
          path="/admin/add_match"
          element={
            <Container>
              <Breadcrumbs />
              <AddMatchResult mode="NEW" />
            </Container>
          }
        />
        <Route
          path="/admin/edit_match"
          element={
            <Container>
              <Breadcrumbs />
              <AddMatchResult mode="EDIT" />
            </Container>
          }
        />
        <Route
          path="/clubs"
          element={
            <Container>
              <Breadcrumbs />
              <Clubs />
            </Container>
          }
        />
        <Route
          path="/future_matches"
          element={
            <Container>
              <Breadcrumbs />
              <FutureMatches />
            </Container>
          }
        />
        <Route
          path="/admin/match_details"
          element={
            <Container>
              <Breadcrumbs />
              <MatchDetails />
            </Container>
          }
        />
        <Route
          path="/admin"
          element={
            <Container>
              <Breadcrumbs />
              <Admin />
            </Container>
          }
        />
        <Route
          path="/team_details"
          element={
            <Container>
              <Breadcrumbs />
              <TeamDetails />
            </Container>
          }
        />
        <Route
          path="/match_details"
          element={
            <Container>
              <Breadcrumbs />
              <MatchDetails />
            </Container>
          }
        />
        <Route path="/statistics" element={<Statistics />} />
        <Route
          path="/"
          element={
            <Container>
              <Seasons />
            </Container>
          }
        />
      </Routes>
    </Container>
  );
};

export default MainContainer;
